import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Flyout } from '@els/els-react--flyout';
import AvailabilityProvidersComponent from '@Components/Results/structure/availability/availability-providers.component';
import { getShoppingCartIcon, loadShoppingCartImage } from '@Components/Results/structure/availability/ShoppingCartHelper';

// RX-3549 - remove imports once feature switcher is removed
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import HoverTooltip from '@Components/HoverTooltip';
import { TooltipConstants } from '@Components/Tooltip';
import ReactDOMServer from 'react-dom/server';
import ShoppingCartTooltipContent from '@Components/Results/structure/availability/ShoppingCartTooltipContent';
import Catalyst from '@Services/Catalyst';

export default class ShoppingCartContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu(isOpen) {
    const { onOpen, trackingContent } = this.props;
    this.setState({ isOpen });
    if (isOpen) {
      const tooltip = document.getElementById(TooltipConstants.ids.GlobalHover);
      if (tooltip) {
        tooltip.dispatchEvent(
          new MouseEvent('mouseleave', {
            bubbles: true,
          })
        );
      }
      onOpen();
      // AA track opening
      Catalyst.trackEvent('buttonClick', {
        buttonType: 'menu:shopping cart', // v124
        content: trackingContent,
      });
    }
  }

  render() {
    const { tooltipId, tooltipPlace, supplierNumber, structure, trackingContext, onOptionClick, availability } = this.props;
    const details = structure.details || {};
    const { isOpen } = this.state;
    const tooltipLabel = 'Commercial Suppliers';
    const shoppingCartTooltipLabel = 'Number of Suppliers';
    return (
      <div className="shopping-cart-block">
        {Auth.isFeatureEnabled(FEATURES.enableDisplaySupplierNumber) && !!supplierNumber && (
          <HoverTooltip
            id={tooltipId}
            tooltip={shoppingCartTooltipLabel}
            className="shopping-cart-tooltip"
            place={tooltipPlace}
            theme="simple">
            <span className="shopping-cart-icon-number" title={tooltipId ? null : shoppingCartTooltipLabel}>
              {supplierNumber}
            </span>
          </HoverTooltip>
        )}

        <Flyout
          className="structure-toolbar-options"
          flyout={
            <div className="u-els-nowrap" data-testid="shopping-cart-flyout">
              <div className="u-els-margin-bottom-1o2 u-els-font-size-h4">Substance Availability</div>
              <AvailabilityProvidersComponent
                closeMenu={noop}
                providers={availability.providers}
                loadImage={loadShoppingCartImage}
                structure={structure}
                trackingContext={trackingContext}
                onProviderClick={onOptionClick}
                isOpen={isOpen}
              />
            </div>
          }
          shouldCloseOnESC
          showCloseButton
          onToggle={this.toggleMenu}
          placement="bottom-start"
          pointerType="primary">
          <HoverTooltip
            id={TooltipConstants.ids.GlobalHover}
            tooltip={ReactDOMServer.renderToString(<ShoppingCartTooltipContent details={details} />)}
            place={tooltipPlace}
            theme="simple">
            <button
              type="button"
              onClick={this.toggleMenu}
              aria-label="Substance Availability"
              title={tooltipId ? null : tooltipLabel}
              className="els-btn els-btn-link els-btn-sm structure-options-button e2e-dropdown e2e-substance-availability structure-availability-button">
              <svg className="els-btn-icon els-btn-icon-sm" focusable="false">
                <use xlinkHref={getShoppingCartIcon(details)} />
              </svg>
              <span className="screen-reader-text">Substance Availability</span>
            </button>
          </HoverTooltip>
        </Flyout>
      </div>
    );
  }
}

ShoppingCartContent.defaultProps = {
  onOpen: () => null,
  onOptionClick: () => null,
};

ShoppingCartContent.propTypes = {
  availability: PropTypes.object.isRequired,
  structure: PropTypes.object.isRequired,
  trackingContext: PropTypes.string,
  onOpen: PropTypes.func,
  onOptionClick: PropTypes.func,
  supplierNumber: PropTypes.number,
  tooltipId: PropTypes.string,
  tooltipPlace: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  trackingContent: PropTypes.array,
};
